module.exports = __webpack_public_path__ + "static/media/login_bg.34f8e34b.jpg";